import useFetchHelpCenter from 'app/hooks/fetch/useFetchHelpCenter';
import { InterstitialPage } from 'app/services/helpCenter';
import { useCallback } from 'react';

const defaultPageContent: InterstitialPage = {
  display_interstitial: false,
  header_text: '',
  content_text: '',
  button_text: '',
};

export default function useInterstitialPage() {
  const { data: helpCenter } = useFetchHelpCenter();
  const domainSpecificPages = helpCenter?.domain_interstitial_pages;
  const generalPage = helpCenter?.interstitial_page;

  const getPageForDomain = useCallback(
    (url: string) => {
      const isDomainMatched = (domain: string) => url?.includes(domain);
      const isPageEnabled = (page: InterstitialPage) => page.display_interstitial;
      const doesPageMatchDomain = (page: InterstitialPage) => page.domains?.some(isDomainMatched);

      return domainSpecificPages?.filter(isPageEnabled)?.find(doesPageMatchDomain);
    },
    [domainSpecificPages]
  );

  const getInterstitialPageForURL = useCallback(
    (url: string) => getPageForDomain(url) || generalPage || defaultPageContent,
    [generalPage, getPageForDomain]
  );

  const isInterstitialEnabledForURL = useCallback(
    (url: string): boolean => !!getPageForDomain(url) || generalPage?.display_interstitial || false,
    [generalPage, getPageForDomain]
  );

  return {
    getInterstitialPageForURL,
    isInterstitialEnabledForURL,
  };
}
